require('./bootstrap');

window.GreenAudioPlayer = require('green-audio-player');

GreenAudioPlayer.init({
    selector: '.audio-player',
    stopOthersOnPlay: true
});